import React, { useState, useMemo } from 'react';
import { Popover, Button } from 'antd';
import useMediaQuery from '../../Hooks/useMediaQuery';
import ShareLike from '../ShareLike/ShareLike';
import { ChevronDown } from '../../assets/icons';
import { useSelector } from 'react-redux';
import './PropertyNav.scss';
import { useLocation, useParams } from 'react-router-dom';
import { PROPERTY_SUB_TYPE, PROPERTY_TYPES } from '../../utils/constant';
import { maxShareCalculatorWithNoOfShare } from '../../utils/maxShareCalculator';
import { remainingDays } from '../../utils/remainingDaysCalculator';

const PropertyNav = (props) => {
  const isMD = useMediaQuery('(min-width: 1000px)');
  const [popoverOpen, setPopoverOpen] = useState(false);
  const location = useLocation();
  const { propertyType } = useParams();
  const { data } = useSelector((state) => state.propertyDetails);
  const notifyLoading = useSelector((state) => state.notifyMeSlice.loading);
  const isSecondaryMarketPaused = useSelector(
    (state) => state.secondaryOffering.sliderData?.data?.isSecondaryMarketPaused === true
  );
  const ACTIVE_STRING = {
    '#about': 'About',
    '#management': 'Management',
    '#tenant-status': 'Tenant status',
    '#market': 'Realbricks Market',
    '#performance': 'Performance',
    '#offering': 'Offering details',
    '#faq': 'FAQ',
  };
  const fundingProgress = useMemo(() => {
    // if (data?.data?.totalShare && data?.data?.sharesPurchased) {
    //   return getUsPercentageFormat((Number(data?.data?.sharesPurchased) * 100) / Number(data?.data?.totalShare), 4);
    // }
    if (data?.data?.percentageFunded) {
      return data?.data?.percentageFunded;
    }
    return 0;
  }, [data?.data?.percentageFunded]);
  return (
    <>
      {!!isMD ? (
        <div className='property-nav property-nav--desktop container-fluid'>
          <ul className='property-nav__list'>
            <li className={`property-nav__list__item ${location.hash === '#about' ? 'active' : ''}`}>
              <a href='#about'>About</a>
            </li>
            {data?.data?.propertyTypeName?.toLowerCase() === PROPERTY_SUB_TYPE.VACATION.toLowerCase() ? (
              <li className={`property-nav__list__item ${location.hash === '#management' ? 'active' : ''}`}>
                <a href='#management'>Management</a>
              </li>
            ) : (
              <li className={`property-nav__list__item ${location.hash === '#tenant-status' ? 'active' : ''}`}>
                <a href='#tenant-status'>Tenant status</a>
              </li>
            )}
            <li className={`property-nav__list__item ${location.hash === '#market' ? 'active' : ''}`}>
              <a href='#market'>Realbricks Market</a>
            </li>
            <li className={`property-nav__list__item ${location.hash === '#performance' ? 'active' : ''}`}>
              <a href='#performance'>Performance</a>
            </li>
            <li className={`property-nav__list__item ${location.hash === '#offering' ? 'active' : ''}`}>
              <a href='#offering'>Offering details</a>
            </li>
            <li className={`property-nav__list__item ${location.hash === '#faq' ? 'active' : ''}`}>
              <a href='#faq'>FAQ</a>
            </li>
          </ul>
          <ShareLike className='ml-auto' />
        </div>
      ) : (
        <div className='property-nav property-nav--mobile container-fluid'>
          <Popover
            placement='bottom'
            overlayClassName='prop-pop'
            open={popoverOpen}
            getPopupContainer={() => document.getElementById('popup-contain')}
            content={
              <>
                <div className='fz-16 fw-600 mb-24'>
                  <a className='text-almost-black' href='#about' onClick={() => setPopoverOpen(false)}>
                    About
                  </a>
                </div>
                <div className='fz-16 fw-600 mb-24'>
                  {data?.data?.propertyTypeName?.toLowerCase() === PROPERTY_SUB_TYPE?.VACATION.toLowerCase() ? (
                    <a className='text-almost-black' href='#management' onClick={() => setPopoverOpen(false)}>
                      Management
                    </a>
                  ) : (
                    <a className='text-almost-black' href='#tenant-status' onClick={() => setPopoverOpen(false)}>
                      Tenant status
                    </a>
                  )}
                </div>
                <div className='fz-16 fw-600 mb-24'>
                  <a className='text-almost-black' href='#market' onClick={() => setPopoverOpen(false)}>
                  Realbricks Market
                  </a>
                </div>
                <div className='fz-16 fw-600 mb-24'>
                  <a className='text-almost-black' href='#performance' onClick={() => setPopoverOpen(false)}>
                    Performance
                  </a>
                </div>
                <div className='fz-16 fw-600 mb-24'>
                  <a className='text-almost-black' href='#offering' onClick={() => setPopoverOpen(false)}>
                    Offering details
                  </a>
                </div>
                <div className='fz-16 fw-600'>
                  <a className='text-almost-black' href='#faq' onClick={() => setPopoverOpen(false)}>
                    FAQ
                  </a>
                </div>
              </>
            }
          >
            <div className='d-flex g-8 share'>
              <span onClick={() => setPopoverOpen(!popoverOpen)} className='d-flex align-items-center fw-600 text-almost-black fz-16 cursor-pointer'>
                {ACTIVE_STRING?.[location.hash] || ACTIVE_STRING?.['#about']} <ChevronDown size={20} />
              </span>
            </div>
          </Popover>
          {propertyType === PROPERTY_TYPES.SECONDARY ? (
            <>
              {data?.data?.tag === 'Coming Soon' ? (
                <Button
                  className='ml-auto py-4 px-8'
                  onClick={() => props?.onNotifyClick({ id: data?.data?.propertyId, isSecondary: data?.data?.isSecondary })}
                  loading={notifyLoading}
                  disabled={isSecondaryMarketPaused}
                >
                  Notify me
                </Button>
              ) : data?.data?.tag !== 'Funded' && 
                   data?.data?.tag !== 'Closed' && 
                   !data?.data?.tag?.startsWith('Next Investment Window:') ? (
                <Button className='ml-auto' type='primary' onClick={props?.onTradeClick} disabled={isSecondaryMarketPaused}>
                  Trade
                </Button>
              ) : null}
            </>
          ) : (
            <>
              {data?.data?.tag === 'Coming Soon' ? (
                <Button
                  className='ml-auto py-4 px-8'
                  onClick={() => props?.onNotifyClick({ id: data?.data?.propertyId, isSecondary: data?.data?.isSecondary })}
                  loading={notifyLoading}
                  disabled={isSecondaryMarketPaused}
                >
                  Notify me
                </Button>
              ) : data?.data?.tag !== 'Funded' && 
                   data?.data?.tag !== 'Closed' && 
                   !data?.data?.tag?.startsWith('Next Investment Window:') ? (
                <>
                  {remainingDays(data?.data?.duration) >= 0 && (
                    <Button
                      disabled={
                        Number(fundingProgress) >= 100 ||
                        maxShareCalculatorWithNoOfShare(Number(data?.data?.totalShare), 0, Number(data?.data?.userPurchaseDetail?.noOfShares)) < 1 ||
                        isSecondaryMarketPaused
                      }
                      className='ml-auto py-4 px-8'
                      type='primary'
                      onClick={props.onBuyClick}
                      loading={props.isFetchingUserAccount}
                    >
                      Buy
                    </Button>
                  )}
                </>
              ) : null}
            </>
          )}

          <div id='popup-contain' />
        </div>
      )}
    </>
  );
};

export default PropertyNav;
